import type { NewApptState } from '../types';

const selectServiceCustomTotalPrice = (state: NewApptState) => state.newAppt.services.custom.totalPrice;

export { selectServiceCustomTotalPrice };
